import React, { useMemo } from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionOneTitle from "hooks/form/blocks/useSectionOneTitle";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum } from "types/enums";

function SectionOneTitleForm({ blockId, bigTitle }: { blockId: BlockEnum; bigTitle?: boolean }) {
    const { buttonDelete, formHook } = useSectionOneTitle();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    const secondText = useMemo(() => {
        if (bigTitle) {
            return "Seconda parte del titolo";
        } else if (blockId === BlockEnum.SectionTitleWithRightTextsAndButton) {
            return "URL del bottone";
        }

        return "Sottotitolo sopra titolo";
    }, [bigTitle, blockId]);

    const thirdText = useMemo(() => {
        if (bigTitle) {
            return "Sottotitolo";
        } else if (blockId === BlockEnum.SectionTitleWithRightTextsAndButton) {
            return "Testo nel bottone";
        }

        return "Testo a sinistra";
    }, [bigTitle, blockId]);

    const fourthText = useMemo(() => "Testo a destra", []);

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={bigTitle ? "Prima parte del titolo" : "Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_one}
                                            setValue={setValue}
                                            path={"text.it.text_one"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={secondText}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_two}
                                            setValue={setValue}
                                            path={"text.it.text_two"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={thirdText}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_three}
                                            setValue={setValue}
                                            path={"text.it.text_three"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={fourthText}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_four}
                                            setValue={setValue}
                                            path={"text.it.text_four"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={bigTitle ? "Prima parte del titolo" : "Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_one}
                                            setValue={setValue}
                                            path={"text.en.text_one"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={secondText}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_two}
                                            setValue={setValue}
                                            path={"text.en.text_two"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={thirdText}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_three}
                                            setValue={setValue}
                                            path={"text.en.text_three"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={fourthText}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_four}
                                            setValue={setValue}
                                            path={"text.en.text_four"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionOneTitleForm;
